import Axios from 'axios'
import { UPDATE_ME, UPDATE_TENANT_INFO } from 'src/store/types'

export function login(params) {
  return Axios.post('/pub/login', params)
    .then(async (res) => {
      $store.commit(UPDATE_ME, res.data)
      return res
    })
}

export function verification() {
  return Axios.get('/pub/captcha')
}

export function logout() {
  return Axios.post('/pub/logout')
    .then(async (res) => {
      $store.commit(UPDATE_ME, null)
      $store.commit(UPDATE_TENANT_INFO, null)
      return res
    })
}

export function uc() {
  return Axios.get('/uc/profile', { ignoreError: true })
    .then(async (res) => {
      $store.commit(UPDATE_ME, res.data)
      return res
    })
}

export function updatePwd(params) {
  return Axios.post('/uc/update/password', params)
}

export function tenantInfo() {
  return Axios.get('/uc/tenant/info')
    .then(async (res) => {
      $store.commit(UPDATE_TENANT_INFO, res.data)
      return res
    })
}
